// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KY-C","newExpiryDate":"styles_newExpiryDate__g3N-D","footer":"styles_footer__-mflJ"};